export function getDeclension(number: number, forms: [string, string, string]): string {
    const mod10 = number % 10;
    const mod100 = number % 100;

    if (mod10 === 1 && mod100 !== 11) {
        return `${number} ${forms[0]}`; // Например: 1 магазине
    } else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
        return `${number} ${forms[1]}`; // Например: 2 магазина
    } else {
        return `${number} ${forms[2]}`; // Например: 5 магазинов
    }
}

export function getProductCountDescription(count: number): string {
    if (count <= 2) {
        return "мало";
    } else if (count > 2 && count <= 10) {
        return "достаточно";
    } else if (count > 10) {
        return "много";
    } else {
        return `${count}`;
    }
}

export function formatNumberWithSpaces(value: number | string): string {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '0';
    
    return Math.floor(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function formatPhoneNumberFlexible(phoneNumber: string): string {
  // Убираем все нецифровые символы
  const digitsOnly = phoneNumber.replace(/\D/g, '');
  
  // Если номер начинается с 7 или 8 (российский номер)
  if (digitsOnly.length === 11 && (digitsOnly.startsWith('7') || digitsOnly.startsWith('8'))) {
    const numberWithoutCode = digitsOnly.substring(1);
    return `+7 ${numberWithoutCode.substring(0, 3)} ${numberWithoutCode.substring(3, 6)} ${numberWithoutCode.substring(6, 8)} ${numberWithoutCode.substring(8, 10)}`;
  }
  
  // Если номер уже с +7 и 11 цифр
  if (phoneNumber.startsWith('+7') && digitsOnly.length === 11) {
    const numberWithoutCode = digitsOnly.substring(1);
    return `+7 ${numberWithoutCode.substring(0, 3)} ${numberWithoutCode.substring(3, 6)} ${numberWithoutCode.substring(6, 8)} ${numberWithoutCode.substring(8, 10)}`;
  }
  
  // Если ничего не подошло, возвращаем оригинал
  return phoneNumber;
}